import { render, staticRenderFns } from "./CadastroDeslocamento.vue?vue&type=template&id=45c526e6&scoped=true"
import script from "./CadastroDeslocamento.vue?vue&type=script&lang=js"
export * from "./CadastroDeslocamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c526e6",
  null
  
)

export default component.exports